export const MAINMAP_LEFT_SIDE_PORTAL_CONSTANT = 'MAINMAP_LEFT_SIDE_PORTAL';
